/* global App, AmCharts */

App.Charts = {
    amcharts: window.AmCharts,
    export: {
        enabled: true,
        dateFormat: "DD.MM.YYYY JJ:NN:SS",
        exportTitles: true,
        libs: {
            path: "/dist/js/amcharts-export/"
        },
        menu: [{
            class: "export-main",
            menu: [{
                label: "Stáhnout ... ",
                menu: ["PNG", "JPG", "PDF"]
            }, {
                label: "Uložit data ... ",
                menu: ["CSV", "XLSX"]
            }, {
                action: "draw",
                label: "Kreslit",
                menu: [{
                    class: "export-drawing",
                    menu: [{
                        label: "Úpravy ... ",
                        menu: [
                            {action: "UNDO", label: "Zpět"},
                            {action: "REDO", label: "Znovu"}
                        ]
                    }, {
                        action: "draw.colors",
                        label: "Barva"
                    }, {
                        label: "Uložit jako ... ",
                        menu: ["PNG", "JPG", "PDF"]
                    }, {
                        action: "CANCEL",
                        label: "Zrušit"
                    }]
                }]
            }]
        }],
        menuReviver: function (cfg, li) {
            if (cfg.format === "XLSX") {
                cfg.dateFormat = "DD.MM.YYYY JJ:NN:SS";
            }
            if (cfg.format === "PDF") {
                cfg.pageOrientation = "landscape";
                cfg.content = [{"image": "reference", "fit": [769.89, 523.28]}];
            }
            return li;
        }
    }
};
